const CHANGE_PASSWORD_EVENTS = {
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAILURE: 'CHANGE_PASSWORD_FAILURE'
};
const LOGIN_EVENTS = {
  LOGIN_START: 'LOGIN_START',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  GET_PROFILE_START: 'GET_PROFILE_START',
  GET_PROFILE_SUCCESS: 'GET_PROFILE_SUCCESS',
  GET_PROFILE_FAILURE: 'GET_PROFILE_FAILURE',
  USER_NOT_EXIST: 'USER_NOT_EXIST'
};
const RESET_EVENTS = {
  RESET_START: 'RESET_START',
  RESET_SUCCESS: 'RESET_SUCCESS',
  RESET_FAILURE: 'RESET_FAILURE',
  RESET_TOKEN_SUCCESS: 'RESET_TOKEN_SUCCESS',
  RESET_TOKEN_FAILURE: 'RESET_TOKEN_FAILURE',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',
  GET_PROFILE_START: 'GET_PROFILE_START',
  GET_PROFILE_SUCCESS: 'GET_PROFILE_SUCCESS',
  GET_PROFILE_FAILURE: 'GET_PROFILE_FAILURE'
};
const PROFILE_EVENTS = {
  PROFILE_START: 'PROFILE_START',
  PROFILE_SUCCESS: 'PROFILE_SUCCESS',
  PROFILE_FAILURE: 'PROFILE_FAILURE',
  PROFILE_POST_SUCCESS: 'PROFILE_POST_SUCCESS',
  PROFILE_POST_FAILURE: 'PROFILE_POST_FAILURE',
  IMAGE_UPLOAD_SUCCESS: 'IMAGE_UPLOAD_SUCCESS',
  IMAGE_UPLOAD_FAILURE: 'IMAGE_UPLOAD_FAILURE'
};
const REGISTER_EVENTS = {
  REGISTER_START: 'REGISTER_START',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_FAILURE: 'REGISTER_FAILURE'
};
const ACCOUNT_VERIFICATION_EVENTS = {
  VERIFICATION_SUCCESS: 'VERIFICATION_SUCCESS',
  VERIFICATION_FAILURE: 'VERIFICATION_FAILURE'
};
const CHANGE_EMAIL_EVENTS = {
  CHANGE_EMAIL_SUCCESS: 'CHANGE_EMAIL_SUCCESS',
  CHANGE_EMAIL_FAILURE: 'CHANGE_EMAIL_FAILURE',
  CHANGE_EMAIL_VERIFICATION_SUCCESS: 'CHANGE_EMAIL_VERIFICATION_SUCCESS',
  CHANGE_EMAIL_VERIFICATION_FAILURE: 'CHANGE_EMAIL_VERIFICATION_FAILURE'
};
const CHANGE_PHONE_EVENTS = {
  CHANGE_PHONE_SUCCESS: 'CHANGE_PHONE_SUCCESS',
  CHANGE_PHONE_FAILURE: 'CHANGE_PHONE_FAILURE',
  CHANGE_PHONE_VERIFICATION_SUCCESS: 'CHANGE_PHONE_VERIFICATION_SUCCESS',
  CHANGE_PHONE_VERIFICATION_FAILURE: 'CHANGE_PHONE_VERIFICATION_FAILURE'
};
const USER_PREFERENCES_EVENTS = {
  GET_USER_PREFERENCES_SUCCESS: 'GET_USER_PREFERENCES_SUCCESS',
  GET_USER_PREFERENCES_FAILURE: 'GET_USER_PREFERENCES_FAILURE'
};
export { CHANGE_PASSWORD_EVENTS, LOGIN_EVENTS, RESET_EVENTS, PROFILE_EVENTS, REGISTER_EVENTS, ACCOUNT_VERIFICATION_EVENTS, CHANGE_EMAIL_EVENTS, CHANGE_PHONE_EVENTS, USER_PREFERENCES_EVENTS };